import {Directive, inject, input, OnInit, TemplateRef, ViewContainerRef} from "@angular/core";
import {environment} from "@menu-environment";

export const DEV: (typeof environment.environment)[] = ["local", "dev"];
export const NON_PROD: (typeof environment.environment)[] = [...DEV, "qa"];

export const isDev = (): boolean => DEV.includes(environment.environment);

@Directive({selector: "[dev-feature], [environment-feature]"})
export class DevFeatureDirective implements OnInit {
    public readonly environments = input<(typeof environment.environment)[]>(DEV, {alias: "environment-feature"});

    private readonly templateRef = inject(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);

    ngOnInit(): void {
        if (this.environments().includes(environment.environment)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
